import { Helmet } from "react-helmet";
import {
    Autocomplete,
    Box,
    Button,
    Container,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    Menu,
    MenuItem,
    Paper,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Toolbar,
    Typography,
    Avatar,
    InputAdornment,
    FormGroup,
    FormControlLabel,
    FormHelperText,
    RadioGroup,
    Radio,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import cssVariables from "../../../../theme/cssVariables";
import CloseIcon from "../../../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../../../assets/images/linkedGoal.svg";
import defaultProfile from "../../../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../../../assets/images/arrowLinkedGoal.svg";
import kpiArrow from "../../../../icons/kpiArrow.svg";
import Icon from '@mui/material/Icon';
import fileBrowser from "../../../../icons/file-browser.svg";
import Search from "@mui/icons-material/Search";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as ChevronExpandDown } from "../../../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../../../assets/icons/chevron-expand-up.svg";
import { ReactComponent as AuditLog } from "../../../../assets/icons/auditLog2.svg";
import mygoalService from "../../../../services/mygoal.service";

const useStyles = makeStyles({
    select: {
        '& div ': {
            padding: "7.9px 7.9px 7.9px 15px"
        },
    },
    boxLeft: {
        width: "25%",
        "padding-bottom": "25px",
    },
    boxRight: {
        width: "75%",
        "padding-bottom": "25px",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "border-radius": "0px !important",
        "box-shadow": "none !important"
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: "20px"
    },
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
});


const DialogAuditLog = (props) => {
    const { open, close, del, serial, workloadForm } = props
    const classes = useStyles();
    const { t } = useTranslation();
    const [name, setName] = React.useState("");
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);

    useEffect(() => {
        if (open) {
            if (Util.formatData(serial, false) !== false) {
                mygoalService.getGoalCorporateLogByGoalID(serial).then((rs) => {
                    let data = Util.formatData(rs?.data?.audit_log, [])
                    setItems(data)
                    setMainItems(data)
                    setName(Util.formatData(rs?.data?.goal_name, "-"))
                })
            } else {
                mygoalService.getGoalCorporateLogDelete(workloadForm).then((rs) => {
                    let data = Util.formatData(rs?.data?.audit_log, [])
                    setItems(data)
                    setMainItems(data)
                })
            }
        }
    }, [open]);
    const handleCloseDialog = () => {
        close(false);
    };
    const navigate = useNavigate();

    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            mainItems.sort(function (b, a) {
                if (key === "updated_by") {
                    if (Util.formatData(a[key]?.fullname, "") > Util.formatData(b[key]?.fullname, "")) {
                        return -1;
                    }
                    if (Util.formatData(b[key]?.fullname, "") > Util.formatData(a[key]?.fullname, "")) {
                        return 1;
                    }
                } else {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                }

                return 0;
            });
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            mainItems.sort(function (a, b) {
                if (key === "updated_by") {
                    if (Util.formatData(a[key]?.fullname, "") > Util.formatData(b[key]?.fullname, "")) {
                        return -1;
                    }
                    if (Util.formatData(b[key]?.fullname, "") > Util.formatData(a[key]?.fullname, "")) {
                        return 1;
                    }
                } else {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                }
                return 0;
            });
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }

    return (
        <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth={"lg"} PaperProps={{ sx: { padding: '30px 30px' } }}>
            <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
                <Box sx={{ display: "flex", alignItems: "center", }}>
                    <Box pr="20px" sx={{ display: "flex", alignItems: "center" }}>
                        <AuditLog />
                    </Box>
                    <Typography fontWeight="600" fontSize={24} lineHeight="26.4px" color="#404349">
                        {del === true ? t('mygoal.label.auditLogDel') : t('mygoal.label.auditLog')}
                    </Typography>
                </Box>
                <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ padding: "0" }}>
                {del === true ? null :
                    <Box display="flex" pt="20px">
                        <Typography w fontWeight="400" fontSize={18} lineHeight="26.91px" color="#A3A3A3" sx={{ width: "125px" }}>
                            {t('corporateGoal.label.goalName')} :
                        </Typography>
                        <Typography fontWeight="400" fontSize={18} lineHeight="26.91px" color="#404349" sx={{ "white-space": "nowrap", width: "calc(100% - 125px)", overflow: "hidden", "text-overflow": "ellipsis", }}>
                            {name}
                        </Typography>
                    </Box>
                }
                <Box sx={{ overflow: "hidden", height: "calc(100vh - 225px)" }}>
                    <div className={classes.root}>
                        <Paper className={classes.flexPaper} >
                            <Box sx={{ background: "#FAFAFA", borderBottom: "1px solid #E5E5E5", borderTop: "1px solid #E5E5E5" }}>
                                {del === true ?
                                    <Box
                                        py="15px"
                                        sx={{ display: "flex", "flex-direction": "row" }}
                                    >
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "calc(100% - 220px)" }} pr="20px" pl="20px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('mygoal.label.deletedGoal')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("detail", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("detail", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "220px" }} pr="20px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('admin.label.updatedBy')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", false)} />
                                            </Typography>
                                        </Box>
                                    </Box>
                                    :
                                    <Box
                                        py="15px"
                                        sx={{ display: "flex", "flex-direction": "row" }}
                                    >
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "20%" }} pr="20px" pl="20px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('admin.label.action')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("action", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("action", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "60%" }} pr="20px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('admin.label.detail')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("detail", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("detail", false)} />
                                            </Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", "flex-direction": "row", width: "20%" }} pr="20px">
                                            <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                {t('admin.label.updatedBy')}
                                            </Typography>
                                            <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", true)} />
                                                <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("updated_by", false)} />
                                            </Typography>
                                        </Box>
                                    </Box>
                                }
                                {/* <Divider width="100%" /> */}
                            </Box>
                            <Box sx={{ overflowY: "overlay", height: " calc(100vh - 400px)" }}>
                                {Util.formatData(items, []).length > 0 ? items.map((row, index) => {
                                    return (
                                        del === true ?
                                            <Box>
                                                <Box sx={{ width: "100%", position: "relative" }}>
                                                    <Box
                                                        sx={{ py: "15px", minHeight: "70px", background: "#FFF", width: "100%", display: "flex" }}
                                                    >
                                                        <Box sx={{ width: "calc(100% - 220px)" }} pr="20px" pl="20px">
                                                            <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                {Util.formatData(row?.detail, "-")}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "220px" }} pr="20px">
                                                            <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                {row?.updated_by?.fullname !== undefined && row?.updated_by?.fullname !== null ? row?.updated_by?.fullname : row?.updated_at !== undefined && row?.updated_at !== null && row?.updated_at !== "" ? "Default" : ""}
                                                            </Typography>
                                                            <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                {Util.dateDayTimeFormatAdmin(row?.updated_at)}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider width="100%" />
                                            </Box>
                                            :
                                            <Box>
                                                <Box sx={{ width: "100%", position: "relative" }}>
                                                    <Box
                                                        sx={{ py: "15px", minHeight: "70px", background: "#FFF", width: "100%", display: "flex" }}
                                                    >
                                                        <Box sx={{ width: "20%" }} pr="20px" pl="20px">
                                                            <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                {row?.action === "delete" ? t('label.delete') : row?.action === "edit" ? t('label.edit') : row?.action === "create" ? t('label.create') : row?.action === "update" ? t('label.status.update') : row?.action === "cascade" ? t('label.cascade') : row?.action === "add" ? t('label.add') : "-"}
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "60%" }} pr="20px">
                                                            <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "margin-right": "10px" }}>
                                                                {Util.formatData(row?.detail, []).length > 0 ? row?.detail.map((dt, indx) =>
                                                                    dt === "goal_name" ? `${t('mygoal.label.goalName')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "goal_details" ? `${t('mygoal.label.goalDetail')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "measurement" ? `${t('mygoal.label.measurement')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "start_date" ? `${t('mygoal.label.startDate')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "end_date" ? `${t('mygoal.label.endDate')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "goal_metric" ? `${t('corporateGoal.label.goalMetric')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "target_condition" ? `${t('corporateGoal.label.targetCondition')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "unit" ? `${t('mygoal.label.unit')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "target_value" ? `${t('corporateGoal.label.targetValue')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "please_specify" ? `${t('corporateGoal.label.specify')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "scale_level" ? `${t('mygoal.label.scaleLevel')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "goal_category" ? `${t('mygoal.label.goalCategory')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "evaluation_weight" ? `${t('mygoal.label.evaluationWeight')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "goal_alignment" ? `${t('mygoal.label.goalAlignment')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "goal_progress" ? `${t('mygoal.label.goalProgress')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "goal_member" ? `${t('mygoal.label.goalMember')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "cascade_goal" ? `${t('corporateGoal.label.cascadeGoal')}${row?.detail.length - 1 !== indx ? ", " : ""}` : dt === "create_goal" ? `${t('mygoal.page.createGoal')}${row?.detail.length - 1 !== indx ? ", " : ""}` : ""
                                                                )
                                                                    :
                                                                    "-"
                                                                }
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: "20%" }} pr="20px">
                                                            <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                {row?.updated_by?.fullname !== undefined && row?.updated_by?.fullname !== null ? row?.updated_by?.fullname : row?.updated_at !== undefined && row?.updated_at !== null && row?.updated_at !== "" ? "Default" : ""}
                                                            </Typography>
                                                            <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                {Util.dateDayTimeFormatAdmin(row?.updated_at)}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Divider width="100%" />
                                            </Box>
                                    )
                                })
                                    :
                                    <Box sx={{ "padding-top": "50px", "text-align": "center" }}>
                                        <Nodata />
                                        <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                            {t('label.noDataFilter')}
                                        </Typography>
                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                            {t('label.tryChangingFilter')}
                                        </Typography>
                                    </Box>
                                }
                            </Box>
                        </Paper>
                    </div>
                </Box>
            </DialogContent>
        </Dialog>
    );
};
export default DialogAuditLog;
